import { render } from "./user-reviews.vue?vue&type=template&id=73a8dc10"
import script from "./user-reviews.vue?vue&type=script&lang=js"
export * from "./user-reviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__